export const KRPANO_XML_VERSION = 'v=2026.06.29.05';
